import { LiquidationMap } from "@/shared/types/chart-risk";

import { LiquidationsDisplay, Param } from "./types";

export const getDisplayData = (data?: LiquidationMap) => {
  const dataWithCentralPoint = data?.liquidations?.map((point, index, arr) => {
    const prevPoint = arr[index - 1];
    const nextPoint = arr[index + 1];
    if (!prevPoint || !nextPoint) {
      return { ...point, isCenterPoint: false };
    }
    const isCenterPoint =
      prevPoint.side !== nextPoint.side && point.price < data.currentPrice;
    return { ...point, isCenterPoint };
  });

  const displayData: LiquidationsDisplay[] | undefined =
    dataWithCentralPoint?.map((point) => {
      const isShort = Boolean(point.side);
      if (point.isCenterPoint) {
        return {
          ...point,
          [isShort ? Param.ShortAmount : Param.LongAmount]: point.amount,
          [Param.ShortCumulativeAmount]: point.cumulativeAmount,
          [Param.LongCumulativeAmount]: point.cumulativeAmount,
        };
      }
      return {
        ...point,
        [isShort ? Param.ShortAmount : Param.LongAmount]: point.amount,
        [isShort ? Param.ShortCumulativeAmount : Param.LongCumulativeAmount]:
          point.cumulativeAmount,
      };
    });

  return displayData;
};
